// 🔹 Try It Button
export default function TryItButton({ code }) {
  const handleClick = () => {
    const encoded = encodeURIComponent(code);
    window.open(`/editorJS?code=${encoded}`, "_blank");
  };
  return (
    <button className="try_it_button" onClick={handleClick}>
      ▶ Try It
    </button>
  );
}
